export default "/images/avatar-3.jpg?2cfd5ba6f0dee8d1d076293e37106695";